import * as React from 'react';
import { ContextualMenu, Dialog, DialogType, Pivot, PivotItem } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { artikelGruppenByNrSelector } from 'store/lookups/selector';
import { useHistory, useParams } from 'react-router-dom';
import { createRecordUrl } from 'utils/formatter';
import { getArtikelDetailId } from 'utils/helper';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { ArtikelDetailEdit } from './ArtikelDetailEdit';
import { ArtikelEdit } from './ArtikelEdit';
import { ArtikelDetailHistorie } from './ArtikelDetailHistorie';
import { ArtikelDetailKalkulationen } from './ArtikelDetailKalkulationen';
import { AddArtikelAttachments } from './AddArtikelAttachments';
import { AddArtikelAttachmentsData } from './types';

const styles = mergeStyleSets({
    itemWrapper: {},
});

const pivotStyles = {
    itemContainer: {},
};

type ArtikelDialogPage = 'artikel' | 'lagerstand' | 'historie' | 'kalkulation';

export interface ArtikelDetailUrlParams {
    subPage?: ArtikelDialogPage;
}

interface ArtikelDialogProps {
    artikelGruppeNr: number; // -1 = new
    artikelNr: string;
    refetch: () => void;
    onClose: () => void;
}

export const ArtikelDialog: React.FC<ArtikelDialogProps> = ({ artikelGruppeNr, artikelNr, onClose, refetch }) => {
    const artikelGruppenByNr = useSelector(artikelGruppenByNrSelector);
    const history = useHistory();
    const { subPage } = useParams<ArtikelDetailUrlParams>();
    const [addArtikelAttachmentData, setAddArtikelAttachmentsData] = React.useState<AddArtikelAttachmentsData | null>(
        null,
    );

    const artikelDetailId = getArtikelDetailId(artikelGruppeNr, artikelNr);

    return (
        <>
            <Dialog
                hidden={false}
                title={`Artikel - ${artikelGruppenByNr[artikelGruppeNr]?.text || '?'} - ${artikelNr}`}
                dialogContentProps={{
                    type: DialogType.normal,
                }}
                modalProps={{
                    isBlocking: true,
                    dragOptions: {
                        moveMenuItemText: 'Move',
                        closeMenuItemText: 'Close',
                        menu: ContextualMenu,
                    },
                }}
                minWidth="90%"
                maxWidth="90%"
                onDismiss={() => {
                    onClose();
                }}
            >
                <Pivot
                    styles={pivotStyles}
                    selectedKey={subPage || 'lagerstand'}
                    onLinkClick={(item) => {
                        history.push(
                            createRecordUrl(
                                'lager/artikel',
                                undefined,
                                artikelDetailId,
                                item?.props.itemKey || 'lagerstand',
                                false,
                            ),
                        );
                    }}
                >
                    <PivotItem itemKey="artikel" headerText="Artikel" className={styles.itemWrapper}>
                        <ArtikelEdit
                            artikelNr={artikelNr}
                            refetch={refetch}
                            setAddArtikelAttachmentsData={setAddArtikelAttachmentsData}
                        />
                    </PivotItem>
                    <PivotItem itemKey="lagerstand" headerText="Lagerstand" className={styles.itemWrapper}>
                        <ArtikelDetailEdit artikelGruppeNr={artikelGruppeNr} artikelNr={artikelNr} refetch={refetch} />
                    </PivotItem>
                    <PivotItem itemKey="historie" headerText="Historie" className={styles.itemWrapper}>
                        <ArtikelDetailHistorie artikelGruppeNr={artikelGruppeNr} artikelNr={artikelNr} />
                    </PivotItem>
                    <PivotItem itemKey="kalkulation" headerText="Kalkulation" className={styles.itemWrapper}>
                        <ArtikelDetailKalkulationen artikelGruppeNr={artikelGruppeNr} artikelNr={artikelNr} />
                    </PivotItem>
                </Pivot>
            </Dialog>
            {addArtikelAttachmentData && (
                <AddArtikelAttachments
                    artikelNr={addArtikelAttachmentData.artikelNr}
                    onClose={(refetch2) => {
                        setAddArtikelAttachmentsData(null);
                        if (refetch2) {
                            addArtikelAttachmentData?.refetch();
                        }
                    }}
                />
            )}
        </>
    );
};
